export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAgA2dL71kuZVpio1jGBLp6mIgrmyHm4qM',
  authDomain: 'awesome-cleanup.firebaseapp.com',
  projectId: 'awesome-cleanup',
  storageBucket: 'awesome-cleanup.appspot.com',
  messagingSenderId: '360997164233',
  appId: '1:360997164233:web:7d829e202c0945bcd72918',
  measurementId: 'G-L4J2DPD6P9',
};
